import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import MicrosoftAzureIntegration from "../MicrosoftAzure/MicrosoftAzure";

const MicrosoftOffice365Integration = () => {
  const [searchParams] = useSearchParams();
  const [guideMode, setGuideMode] = useState(false);

  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);
  return (
    <MicrosoftAzureIntegration
      integrationName="microsoft_office_365"
      guideMode={guideMode}
    ></MicrosoftAzureIntegration>
  );
};

export default MicrosoftOffice365Integration;
